import OutcomesV1 from "./OutcomesV1";

export default OutcomesV1;
